import { configureStore } from '@reduxjs/toolkit';
import vaultReducer from './vault-slice';
import adviserReducer from './adviser-slice';
import { syncMiddleware } from './middleware/sync-middleware';

export const store = configureStore({
  reducer: {
    vault: vaultReducer,
    adviser: adviserReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(syncMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;